import React from "react";
import Header from "../components/Header";
import BioHeroSection from "../components/BioHeroSection";
import BioNewsSection from "../components/BioNewsSection";
import MediaSection from "../components/MediaSection";
import "../styles/Home.css"; // General styles

function Home() {
  return (
    <div className="Wrapper">
      <div className="Home">
        <Header />
        <BioHeroSection />
        <BioNewsSection />
        <MediaSection />
        <div className="footer">
          <p>Copyright © 2024, Frank Fundel</p>
        </div>
      </div>
    </div>
  );
}

export default Home;
